
let filterOpen = false;

const journalFilterMobile = () => {
    const trigger = document.querySelector('.article-filter-button-mobile');

    copy_element = document.querySelector(".article-filter.mobile");
    
    if ( trigger ) {
        console.log(trigger);

        trigger.addEventListener('click', (e) => {
            e.preventDefault();

            if ( !filterOpen ) {
                //add class
                copy_element.classList.add("active");
                trigger.classList.add("active");
                trigger.innerHTML = 'Close x';

            } else {

                //remove class
                copy_element.classList.remove("active");
                trigger.classList.remove("active");
                trigger.innerHTML = 'article filter +';
            }

            filterOpen = !filterOpen;
        });
    }
    
};

journalFilterMobile();